import React, { useEffect, useState } from 'react'
import ContentButton from '../ContentButton/ContentButton'
import styles from './Personal.module.css'
import { student } from '../../store/student.ts'
import { directory } from '../../store/directory'
import { observer } from 'mobx-react-lite'
import { property } from '../../store/poperty'
import http from '../../Service/http'
import DemandModal from './../Modal/DemandModal'
import { useTranslation } from 'react-i18next'
import { appName } from '../../Service/http'

export default observer(function Personal() {
	const [demand, setDemand] = useState(false)
	const { t } = useTranslation()

	const getObjIdid = async () => {
		const res = await http.get(`/okno/obj?id_student=${student.student.id_student}&id_group=${student.student.id_group}`)
		property.newStudentInf(res.data.StudentInf[0])
		property.newMale(res.data.Male[0])
	}

	const getStudPhoto = async () => {
		const res = await http.post('/okno/image', {
			id_student: student.student.id_student,
			id_group: student.student.id_group
		})
		if (res.data.base64data) {
			student.newPhoto(res.data.base64data)
		} else {
			student.newPhoto('')
		}
	}

	useEffect(() => {
		if (student.student.id_student) {
			getObjIdid()
			getStudPhoto()
		}
	}, [student.student.id_student])

	return (
		<div className={styles.StudentInformation}>
			<DemandModal isOpen={demand} setIsOpen={setDemand} />
			<div className={styles.About_person}>
				<div className={styles.Ava_person}>
					<img src={student.photo ? student.photo : '/bt/img/user.png'} alt='Avatar' />
				</div>
				<div className={styles.Fio_person}>
					<h3>{student.student.fio ? student.student.fio : 'ФИО'}</h3>

					<p>
						{student.student.id_faculty
							? directory.facultyList.find(item => item.value == student.student.id_faculty).label
							: t('st:selects.faculty')}
					</p>
					<p>{student.student.p22 ? student.student.p22 : t('st:selects.rate')}</p>
					<p>{student.student.p20 ? student.student.p20 : t('st:selects.group')}</p>
					<p>{property.studentInf.idid ? property.studentInf.idid : 'ID'}</p>
				</div>
			</div>
			<ContentButton
				style={student.student.id_student ? { opacity: '1' } : { opacity: '0.7' }}
				icon={<i className='fas fa-file-alt'></i>}
				name={t('st:other.demand')}
				onClick={() => {
					if (student.student.id_student) {
						setDemand(true)
					}
				}}
			/>
		</div>
	)
})
